import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { NavigationStart, Router, RouterOutlet } from '@angular/router';

import { Subscription } from 'rxjs';

import { ContentService } from '@services/content/content.service';

import { LoadingSpinnerComponent } from './core/components/loading-spinner/loading-spinner.component';

export let browserRefresh = false;

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoadingSpinnerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements AfterViewInit, OnDestroy {
  subscription: Subscription;

  constructor(
    private router: Router,
    private contentService: ContentService
  ) {
    this.subscription = router.events.subscribe(event => {
      /**
       * IS login, redirect back to sign-in rout
       */
      if (event instanceof NavigationStart && event.url !== '/' && !event.url.includes('sign-in')) {
        browserRefresh = !router.navigated;

        if (browserRefresh) {
          this.router.navigate(['/']);
        }
      }
    });
  }

  onResize(event: Event): void {
    const w = (event.target as Window).innerWidth;
    this.isMobileCheck(w);
  }

  ngAfterViewInit(): void {
    this.isMobileCheck(window.innerWidth);
  }

  isMobileCheck(innerWidth: number): void {
    if (innerWidth <= 992) {
      this.contentService.setIsMobile(true);
    } else {
      this.contentService.setIsMobile(false);
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
